import { getDateIn2Hours } from '@anm/components/stream/NewStreamModal/hooks/useStreamDate/helpers';
import { InitialEditModalState } from '@anm/components/stream/types';
import isEqual from 'lodash/fp/isEqual';
import pick from 'lodash/pick';
import { LiveStreamKind } from 'types/stream';

import { UpdateMetaProps } from './types';

export const getCanUpdateStreamMeta = (newProps: UpdateMetaProps, initialEditModalState?: InitialEditModalState) => {
  const newValues = pick(newProps, 'title', 'preview', 'description', 'folderId');
  const oldValues = pick(initialEditModalState, 'title', 'preview', 'description', 'folderId');

  const isScheduleTimeEqual =
    !!initialEditModalState?.schedule &&
    new Date(newProps.schedule).getTime() === new Date(initialEditModalState.schedule).getTime();

  return !isEqual(newValues, oldValues) || !isScheduleTimeEqual;
};

export const getStreamKind = (projectId?: string, initialKind?: LiveStreamKind): LiveStreamKind =>
  !!projectId || initialKind === 'HOSTED' ? 'HOSTED' : 'LIVE';

export const getInitialModalDate = (schedule?: string | null, isDuplicate?: boolean) => {
  const dateIn2Hours = getDateIn2Hours();

  return !schedule ? null : isDuplicate ? dateIn2Hours : new Date(schedule).getTime();
};
